import { ApppointmentsContainerComponent } from "@/lib/appointments/container/component"
import { consumeBookingSearch } from "@/lib/bookingSearch/consume"
import { consumeCaching } from "@/lib/caches/consume"
import { consumeLoading } from "@/lib/consume/loading"
import { consumeRouter } from "@/lib/consume/router"
import { Notices } from "@/lib/notices"
import { consumeServices } from "@/lib/services/consume"

export const AppointmentsContainerConsumer = consumeLoading(
  consumeRouter(
    Notices.consumeFunctions(
      consumeCaching(
        consumeServices(consumeBookingSearch(ApppointmentsContainerComponent))
      )
    )
  )
)
